import { useState } from "react";
import BlockUi from "react-block-ui";
import { Modal } from "react-bootstrap";
import {
  AiOutlineCloseCircle,
  AiOutlineMail,
  AiOutlineQuestionCircle,
  AiOutlineUser,
} from "react-icons/ai";
import { BsChatQuote } from "react-icons/bs";
import { toast } from "react-toastify";
import MyYuukke from "../../../api/MyYuukke";
import PhoneNumberContainer from "../../../components/PhoneNumberContainer";

// Add this CSS to your global styles or use CSS-in-JS
const modernStyles = `
  .modern-modal {
    font-family: 'Inter', sans-serif;
  }
  
  .modal-header-v2 {
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    padding: 1.5rem;
  }
  
  .input-group-v2 {
    position: relative;
    margin-bottom: 1.5rem;
  }
  
  .input-icon {
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    color: #6c757d;
  }
  
  .input-field-v2 {
    width: 100%;
    padding: 0.75rem 1rem 0.75rem 2.5rem;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    transition: all 0.3s ease;
  }
  
  .input-field-v2:focus {
    border-color: #4a90e2;
    box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
  }
  
  .submit-btn-v2 {
    // background: #a00030;
    background: hsl(266 83% 58%);
    color: white;
    padding: 0.75rem 1rem;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self:flex-end;
    // gap: 0.5rem;
  }
  
  .submit-btn-v2:hover {
    background: #357abd;
    transform: translateY(-1px);
  }
  
  .form-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #212529;
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }
`;

export default function ServiceUserForm({
  serviceProviderUserId,
  updateDetails,
  closeModel,
}) {
  const [state, setState] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    loader: false,
    description: "",
  });
  const updateState = (name, value) => {
    setState((previous) => ({
      ...previous,
      [name]: value,
    }));
  };
  const uploadDetails = (e) => {
    e.preventDefault();
    if (!state.name || !state.phoneNumber) {
      toast.warning("Fill all required fields");
    } else {
      updateState("loader", true);

      let data = {
        userName: state.name,
        email: state.email,
        phoneNumber: state.phoneNumber,
        userId: serviceProviderUserId,
        description: state.description,
      };
      MyYuukke.saveServiceChatDetails(data)
        .then((response) => {
          console.log("response", response);
          localStorage.setItem("SERVICE-EMAIL", response.data?.data?.email);
          updateDetails(response.data.data);
          updateState("loader", false);
        })
        .catch((e) => {
          console.log("e", e);
          toast.error("Something went wrong !");
          updateState("loader", false);
          closeModel();
        });
    }
  };

  return (
    <Modal
      show={true}
      onHide={closeModel}
      dialogClassName="modern-modal"
      centered
    >
      <style>{modernStyles}</style>
      <Modal.Header className="modal-header-v2">
        <div className="d-flex justify-content-between align-items-center w-100">
          <h3 className="form-title mb-0">
            <BsChatQuote className="text-primary" />
            Contact Details
          </h3>
          <AiOutlineCloseCircle
            onClick={closeModel}
            className="text-muted"
            style={{
              cursor: "pointer",
              fontSize: "1.5rem",
              transition: "color 0.2s ease",
            }}
          />
        </div>
      </Modal.Header>

      <Modal.Body className="p-4">
        <BlockUi
          tag="div"
          message="Loading..."
          blocking={state.loader}
          className="wallLoadingPage"
        >
          <form onSubmit={uploadDetails} className="d-flex flex-column gap-3">
            <div className="input-group-v2">
              <AiOutlineUser className="input-icon" />
              <input
                className="input-field-v2"
                value={state.name}
                placeholder="Full Name"
                required
                onChange={(e) => updateState("name", e.target.value)}
              />
            </div>

            <div className="input-group-v2">
              <AiOutlineMail className="input-icon" />
              <input
                className="input-field-v2"
                type="email"
                value={state.email}
                placeholder="Email Address"
                required
                onChange={(e) => updateState("email", e.target.value)}
              />
            </div>

            <div className="input-group-v2">
              <PhoneNumberContainer
                value={state.phoneNumber}
                updateData={(e) => updateState("phoneNumber", e)}
                customStyle={{ paddingLeft: "2.5rem" }}
                defaultClass="custom-phone-input"
              />
            </div>

            <div className="input-group-v2">
              <AiOutlineQuestionCircle className="input-icon" />
              <textarea
                className="input-field-v2"
                style={{ minHeight: "100px", resize: "vertical" }}
                value={state.description}
                // placeholder="Describe your query..."
                placeholder="Message"
                required
                onChange={(e) => updateState("description", e.target.value)}
              />
            </div>

            <button type="submit" className="submit-btn-v2 mt-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-send h-4 w-4 mr-2"
              >
                <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"></path>
                <path d="m21.854 2.147-10.94 10.939"></path>
              </svg>
              {/* Submit Request */}
              Send Message
              {state.loader && (
                <div className="spinner-border spinner-border-sm text-light ms-2" />
              )}
            </button>
          </form>
        </BlockUi>
      </Modal.Body>
    </Modal>
  );
}
